import SearchIcon from '@mui/icons-material/Search'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'

type Props = Readonly<{
  value: string
  onChange: (value: string) => void
  placeholder: string
  testId: string
  ariaLabel: string
  /** When true, search grows to fill remaining toolbar width. */
  fullWidth?: boolean
}>

/** Figma `5106:8192` — app header search (389×42, outline #e1e7f3). */
export function AppShellHeaderSearch({
  value,
  onChange,
  placeholder,
  testId,
  ariaLabel,
  fullWidth = false,
}: Props) {
  return (
    <TextField
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel}
      data-testid={testId}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 18, color: '#64748b' }} aria-hidden />
          </InputAdornment>
        ),
      }}
      sx={{
        width: fullWidth ? '100%' : { xs: '100%', sm: 389 },
        maxWidth: fullWidth ? 'none' : 389,
        flex: fullWidth ? 1 : { xs: '1 1 auto', sm: '0 0 auto' },
        '& .MuiOutlinedInput-root': {
          height: 42,
          borderRadius: '10px',
          bgcolor: '#ffffff',
          fontSize: '14px',
          letterSpacing: '-0.1504px',
          color: '#0f172a',
          '& fieldset': {
            borderColor: '#e1e7f3',
            borderWidth: '1px',
          },
          '&:hover fieldset': {
            borderColor: '#e1e7f3',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#008cd0',
            borderWidth: '1px',
          },
        },
        '& .MuiOutlinedInput-input::placeholder': {
          color: '#64748b',
          opacity: 1,
        },
      }}
    />
  )
}
